import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line max-len
import ProductSwatchColoursItemMarkup from '@cotyorg/ccx-organism-product-swatch/components/ProductSwatchColours/ProductSwatchColoursItemMarkup';
import classNames from 'classnames';

export const ShadowWrapper = ({
  selectedProduct,
  swatches,
  vtoActualProductSku,
  onSetProductID,
  setVtoActualProductSku,
  extraClass = '',
  dispatchEvent,
}) => {
  const generateShadowWrapperClassNames = () =>
    classNames(`shadow__wrapper ${extraClass}`);

  return (
    <div className={generateShadowWrapperClassNames()}>
      <div className="shadow">
        <ProductSwatchColoursItemMarkup
          uniqueId={`vto-modal${extraClass}`}
          swatches={swatches}
          selectedSKU={vtoActualProductSku}
          setProductSKU={(sku) =>
            onSetProductID({
              sku,
              swatches,
              selectedProduct,
              setVtoActualProductSku,
              dispatchEvent,
            })
          }
        />
      </div>
    </div>
  );
};

ShadowWrapper.propTypes = {
  selectedProduct: PropTypes.object,
  swatches: PropTypes.array,
  vtoActualProductSku: PropTypes.string,
  onSetProductID: PropTypes.func,
  setVtoActualProductSku: PropTypes.func,
  extraClass: PropTypes.string,
  dispatchEvent: PropTypes.func,
};
